<template>
    <v-container class="pa-6" style="font-family: 'Saira Condensed', sans-serif;">
        <v-card elevation="1" rounded="lg" class="pa-6" color="white">
            <!-- Title with Icon -->
            <div class="d-flex align-center mb-6">
                <v-icon color="primary" class="mr-2">mdi-help-circle-outline</v-icon>
                <h2 class="text-h6" style="font-weight: 600;">Help Center</h2>
            </div>

            <v-expansion-panels multiple elevation="0">
                <!-- Purchase Status Guide -->
                <v-expansion-panel>
                    <v-expansion-panel-title class="text-body-1 font-weight-bold">
                        {{ $t('Purchase_Guidelines.Header') }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <ul>
                            <li><strong>PENDING</strong> – {{ $t('Purchase_Guidelines.Pending') }}</li>
                            <li><strong>IN PROGRESS</strong> – {{ $t('Purchase_Guidelines.In_Progress') }}</li>
                            <li><strong>COMPLETED</strong> – {{ $t('Purchase_Guidelines.Completed') }}</li>
                            <li><strong>DECLINED</strong> – {{ $t('Purchase_Guidelines.Declined') }}</li>
                            <li><strong>REFUND ICON</strong> – {{ $t('Purchase_Guidelines.Refund') }}</li>
                        </ul>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- Divider -->
                <v-divider class="my-2"></v-divider>

                <!-- Guess the Balance Guide -->
                <v-expansion-panel>
                    <v-expansion-panel-title class="text-body-1 font-weight-bold">
                        Guess the Balance
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <div>{{ $t('GTB_Guidelines.Header') }}</div>
                        <ul>
                            <li>{{ $t('GTB_Guidelines.Step_1') }}</li>
                            <li>{{ $t('GTB_Guidelines.Step_2') }}</li>
                            <li>{{ $t('GTB_Guidelines.Step_3') }}</li>
                            <li>{{ $t('GTB_Guidelines.Step_4') }}</li>
                            <li>{{ $t('GTB_Guidelines.Step_5') }}</li>
                            <li class="text-error">{{ $t('GTB_Guidelines.Step_6') }}</li>
                        </ul>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- Divider -->
                <v-divider class="my-2"></v-divider>

                <!-- Raffle System Guide -->
                <v-expansion-panel>
                    <v-expansion-panel-title class="text-body-1 font-weight-bold">
                        {{ $t('Raffle_System_Guide.Header') }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <div class="mb-3">{{ $t('Raffle_System_Guide.Intro') }}</div>

                        <div class="text-subtitle-2 font-weight-medium mb-1">
                        {{ $t('Raffle_System_Guide.Status_Guide.HEADER') }}
                        </div>
                        <ul>
                        <li><strong>ACTIVE</strong> – {{ $t('Raffle_System_Guide.Status_Guide.ACTIVE') }}</li>
                        <li><strong>STARTED</strong> – {{ $t('Raffle_System_Guide.Status_Guide.STARTED') }}</li>
                        <li><strong>STOPPED</strong> – {{ $t('Raffle_System_Guide.Status_Guide.STOPPED') }}</li>
                        <li><strong>ENDED</strong> – {{ $t('Raffle_System_Guide.Status_Guide.ENDED') }}</li>
                        </ul>

                        <div class="text-subtitle-2 font-weight-medium mt-4 mb-1">
                        {{ $t('Raffle_System_Guide.Buttons_Guide.HEADER') }}
                        </div>
                        <ul>
                        <li><strong>START ENTRIES</strong> – {{ $t('Raffle_System_Guide.Buttons_Guide.START_ENTRIES') }}</li>
                        <li><strong>VIEW ENTRIES</strong> – {{ $t('Raffle_System_Guide.Buttons_Guide.VIEW_ENTRIES') }}</li>
                        <li><strong>DRAW</strong> – {{ $t('Raffle_System_Guide.Buttons_Guide.DRAW') }}</li>
                        <li><strong>STOP ENTRIES</strong> – {{ $t('Raffle_System_Guide.Buttons_Guide.STOP_ENTRIES') }}</li>
                        <li><strong>END RAFFLE</strong> – {{ $t('Raffle_System_Guide.Buttons_Guide.END_RAFFLE') }}</li>
                        <li><strong>VIEW WINNERS</strong> – {{ $t('Raffle_System_Guide.Buttons_Guide.VIEW_WINNERS') }}</li>
                        </ul>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-container>
</template>

<style scoped>
ul {
    padding-left: 1rem;
    margin-top: 0.5rem;
    color: #444;
    font-size: 0.95rem;
    line-height: 1.6;
}

li {
    margin-bottom: 6px;
}
</style>